import SearchResultEntity from "../../../../../domain/entities/SearchResultEntity";
import ShiftEntity from "../../../../../domain/entities/ShiftEntity";
import UserEntity from "../../../../../domain/entities/UserEntity";

//TODO implement
const SearchShiftApiImpl = (businessUnitId: string[], supervisorId: string[], employeesIds: string[], groupId: string | undefined, days: Date[], word: string, page: number, itemsPerPage: number): Promise<SearchResultEntity<ShiftEntity>> => {
    throw new Error('Method not implemented.');
}

export default SearchShiftApiImpl;